module.exports = __webpack_public_path__ + "img/0.24c877cd.svg";